<template>
  <div class="demo">
    <h1>你好这里是首页</h1>
  </div>
</template>

<script>
// import E from 'wangeditor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  components: {},
  data() {
    return {
      pageNo: 1,
      total: 0,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {

  },
  // html加载完成后执行。
  mounted() {
    
  },
  // 事件方法执行
  methods: {
    
    
  },
}
</script>

<style lang="scss" scoped>
.demo {
  width: 100vw;
  height: 100vh;
}
</style>
